import { Button, Col, Form, Input, Row, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import './style.scss';
import {  useState } from "react";

const { Option } = Select;

export const FilterFieldsRender = (
    fields: string[],
    setFilterValues?: any,
    filterValues?: any,
    setCloseDrawer?: any,
    type?: string,
) => {
    const [filterForm] = useForm();
    const [hasValues, setHasValues] = useState(true);

    const inputStyle = {
        width: "100%",
        minHeight: '37px',
        paddingLeft: '12px',
        paddingRight: '12px',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: 400,
        background: '#F3F4F6FF',
        borderRadius: '6px',
        borderWidth: '0px',
        outline: 'none'
    };

    const inputLabelStyle = {
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: 700,
        color: '#323743FF',
    };

    const labelName: any = {
        "Inventory No": 'inventoryNo',
        "Title": "title",
        "Artist Name": "artistName",
        "Name": "name",
        "Email": "email",
        "Status": "status",
        "Role": "role"
    };

    // Predefined dropdown options
    const selectOptions: any = {
        "Status": ["ENABLE", "DISABLE"],
        "Role": ["ADMIN", "SELLER"]
    };

    const renderField = (field: string) => {
        const fieldName = labelName[field] || field.toLowerCase();

        return (
            <Form.Item
                key={field}
                label={<span style={inputLabelStyle}>{field}</span>}
                name={fieldName}
            >
                {selectOptions[field] ? (
                    <Select style={inputStyle}>
                        {selectOptions[field].map((option: string) => (
                            <Option key={option} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                ) : (
                    <Input style={inputStyle}  />
                )}
            </Form.Item>
        );
    };

    const onHandleFilterSubmit = (value: any) => {
        setFilterValues(type === 'User' ? { ...value } : [{ ...value }]);
        setCloseDrawer(false);
        setHasValues(true);
    };

    return (
        <Form
            layout="vertical"
            form={filterForm}
            style={{ marginTop: '10px' }}
            onFinish={onHandleFilterSubmit}
            onValuesChange={(changedValues, allValues) => {
                const hasAnyValue = Object.values(allValues).some(
                    (val) => val !== undefined && val !== null && val !== ""
                );
                setHasValues(!hasAnyValue);
            }}

        >
            {fields?.map(renderField)}
            <Row justify="space-between" style={{ marginTop: "15px" }}>
                <Col>
                    <Button
                        danger
                        onClick={() => {
                            setFilterValues(type === 'User' ? {} : []);
                            filterForm.resetFields();
                            setCloseDrawer(false);
                            setHasValues(true);
                        }}
                        disabled=
                        {
                            Object.values(filterForm.getFieldsValue()).some(
                                (val) => val !== undefined && val !==null && val !==""
                            ) ? false : hasValues
                            
                        }
                        style={{ letterSpacing: "0.5px", fontWeight: "bold" }}
                    >
                        Reset
                    </Button>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                            letterSpacing: "0.5px",
                            fontWeight: "bold",
                            background: 'rgb(99, 106, 232)'
                        }}
                    >
                        Apply
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};
